(function ( $ ) {
  jQuery(document).ready(function () {
    // Header active item
    $('.site-nav__dropdown-link').each(function () {
      if ( $(this).hasClass('site-nav__current') ) {
        $(this).parents('.site-nav__details').find('summary.site-nav__link').addClass('site-nav__current');
      }
    });

    // Variable
    function kinkindVariable() {
      var header_height = $('.header-section .site-header__element').outerHeight();
      var heightToolbar = $('.shopify-section-group-header-group.toolbar-section').outerHeight();
      $('body').css('--heightHeader', header_height + 'px');
      $('body').css('--heightToolbar', heightToolbar + 'px');
      $('body').css('--heightScreen', `${window.innerHeight}px`);
    }

    kinkindVariable();
    $(window).on('resize load', function () {
      kinkindVariable();
    });
    $(window).scroll(function () {
      kinkindVariable();
      // Header Fixed
      var scroll = $(window).scrollTop();
      if ( $('.shopify-section-group-header-group.toolbar-section').length > 0 ) {
        var heightToolbar = $('.shopify-section-group-header-group.toolbar-section').outerHeight();
        if ( scroll <= heightToolbar ) {
          heightToolbar = heightToolbar - scroll;
          $('body').css('--heightToolbar', heightToolbar + 'px');
        }
        else {
          $('body').css('--heightToolbar', '0px');
        }
      }
    });

    // Footer mobile
    $('.footer__block--menu .footer__title').click(function () {
      $(this).parents('.footer__block--menu').toggleClass('active');
      $(this).next('ul').slideToggle();
    });
  });

  // global scope required for these variables, as they will hold the interval and counter required to bully the
  // accordions into behaving.
  var
    _interval_counter = 0,
    _interval;

  $(document).ready(function () {
    'use strict';

    /* region ============================ Description Accordion ============================ */

    let
      _label_selector_product = '.kinkind-accordion__label.product-block__label',
      _label_selector_generic = '.kinkind-accordion__label:not(.product-block__label)',
      _next_selector          = '.kinkind-accordion__content-container';

    // Ensure the first item is visible
    $(`${_label_selector_generic}:first-of-type`)
      .addClass('active');
    $(`${_label_selector_generic}:first-of-type + ${_next_selector}`)
      .show();

    // The following code is unfortunately duplicated for each usecase because abstracting the repeated sections
    //  into a function doesn't work for some reason 🤷🏾‍♀️

    /* ---------------------------- Regular Accordions ---------------------------- */
    /* region */

    // Regular accordions:
    $(_label_selector_generic).on('click', function ( e ) {
      let
        $this = $(this),
        $prev = $this.prev('input'),
        $next = $this.next(_next_selector);

      // close all other items
      $next
        .siblings(`${_next_selector}:visible`)
        .slideUp();

      // toggle this item
      $next
        .slideToggle();

      // Sort out 'active' class
      if ( $this.hasClass('active') ) {
        $this
          .removeClass('active');
      }
      else {
        $this
          .addClass('active')
          .siblings(`${_label_selector_generic}.active`)
          .removeClass('active');
      }

      // Enforce checked state:
      // reset the interval
      clearInterval(_interval);
      _interval_counter = 0;

      // Check if the radio button is already checked:
      if ( $prev.prop('checked') ) {
        // Only on smaller viewports:
        if ( $(document).width() < 768 ) {
          // If it is checked, remove the checked state and prevent the default behavior:
          $prev.prop('checked', false);

          // Prevents the radio button from being re-checked:
          e.preventDefault();

          // Absolutely force the interval to clear:
          clearInterval(_interval);

          // Absolutely force the element to behave itself:
          _interval = setInterval(function () {
            $prev.prop('checked', false);
            _interval_counter++;

            if ( _interval_counter > 15 ) {
              clearInterval(_interval);
            }
          }, 11);
        }
      }
      else {
        // If it is not checked, allow the default behavior (which checks the radio button):
        $prev.prop('checked', true);

        // Absolutely force the interval to clear:
        clearInterval(_interval);

        // Absolutely force the element to behave itself:
        _interval = setInterval(function () {
          $prev.prop('checked', true);
          _interval_counter++;

          if ( _interval_counter > 15 ) {
            clearInterval(_interval);
          }
        }, 11);
      }
    });
    /* endregion */

    /* ---------------------------- Product Page Accordions ---------------------------- */
    /* region */

    // Special handling needed for the product page accordion, as this has a completely different layout on larger viewports:
    $(_label_selector_product).on('click', function ( e ) {
      let
        $this = $(this),
        $next = $this.next(_next_selector),
        $prev = $(this).prev('input[type="radio"]');

      // reset the interval
      clearInterval(_interval);
      _interval_counter = 0;

      // Check if the radio button is already checked:
      if ( $prev.prop('checked') ) {
        // Only on smaller viewports:
        if ( $(document).width() < 768 ) {

          // close all other items
          $next
            .siblings(`${_next_selector}:visible`)
            .slideUp();

          // toggle this item
          $next
            .slideToggle();

          // Sort out 'active' class
          if ( $this.hasClass('active') ) {
            $this
              .removeClass('active');
          }
          else {
            $this
              .addClass('active')
              .siblings(`${_label_selector_generic}.active`)
              .removeClass('active');
          }

          // Enforce checked state:

          // If it is checked, remove the checked state and prevent the default behavior:
          $prev.prop('checked', false);

          // Prevents the radio button from being re-checked:
          e.preventDefault();

          // Absolutely force the interval to clear:
          clearInterval(_interval);

          // Absolutely force the element to behave itself:
          _interval = setInterval(function () {
            $prev.prop('checked', false);
            _interval_counter++;

            if ( _interval_counter > 15 ) {
              clearInterval(_interval);
            }
          }, 11);
        }
      }
      else {
        // If it is not checked, allow the default behavior (which checks the radio button):
        $prev.prop('checked', true);

        // Absolutely force the interval to clear:
        clearInterval(_interval);

        // Absolutely force the element to behave itself:
        _interval = setInterval(function () {
          $prev.prop('checked', true);
          _interval_counter++;

          if ( _interval_counter > 15 ) {
            clearInterval(_interval);
          }
        }, 11);
      }
    });
    /* endregion */

    /* endregion */

    /* ============================ Mobile Navigation Accordion ============================ */
    /* region */

    let _kinkind_mobile_nav_event_listeners_assigned = false;

    setTimeout(function () {
      // wait for a few moments before trying to add the event listeners

      // Figure out if the kinkind menu nav is being used or not - as the menu takes an age to load:
      let _kinkind_mobile_nav_interval = setInterval(function () {
        let
          _selector__kinkind_check  = `.js-toggle-submenu--kinkind`,
          _selector__original_check = `.js-toggle-submenu[data-target^='tier-3-']`;

        if ( $(_selector__kinkind_check).length > 0 ) {

          $('head')
            .append(`
              <style id="kinkind-mobile-nav-menu-styles">
                ${_selector__kinkind_check} svg{transition: transform 0.125s ease-in-out;}
                ${_selector__kinkind_check} svg.rotate{transform:rotate(90deg);}
              </style>
            `);

          // Assign the event listeners:

          // Ensure that the navigation wrapper has an appropriate maximum height and can overflow properly.
          // only hide the 3rd tier links after the 2nd tier toggle has been clicked, to work around the theme scripts
          //  dynamically adjusting the container height each time:

          // 2nd tier submenu link
          $(`.js-toggle-submenu`)
            .on('click', function () {
              // Open all submenus to ensure theme code gets the correct height for the container.
              $(`.slide-nav__item .slide-nav__dropdown--kinkind`)
                .removeClass('.slide-nav__dropdown--hidden')
                .show()
                .find('svg') // and reset the rotate state of the SVG arrow.
                .removeClass('rotate');

              setTimeout(function () {
                let
                  $wrapper            = $(`.slide-nav__wrapper`),
                  $dropdown           = $(`.slide-nav__item .slide-nav__dropdown--kinkind`),
                  _2nd_child_selector = `.slide-nav__dropdown.is-active .slide-nav__item:nth-child(2)`,
                  $2nd_child_dropdown = $(`${_2nd_child_selector} .slide-nav__dropdown--kinkind`),
                  $2nd_child_svg      = $(`${_2nd_child_selector} svg`),
                  $back_link          = $(`.slide-nav__dropdown--kinkind .js-toggle-submenu--kinkind`);

                // After a few moments, hide them for the accordion to work:
                $dropdown
                  .addClass('.slide-nav__dropdown--hidden')
                  .hide();

                //  ...except for the first submenu, which the client would like to appear open by default:
                $2nd_child_dropdown
                  .removeClass('.slide-nav__dropdown--hidden')
                  .show();

                // Apply the rotation to the SVG
                $2nd_child_svg
                  .addClass('rotate');

                // Hide the regular unneeded back link:
                $back_link
                  .hide();

                // And apply a max height and fix the overflow to allow scrolling internally:
                $wrapper
                  .css({
                    'overflow-x': 'hidden',
                    'overflow-y': 'auto',
                    'max-height': 'calc(100vh - var(--heightHeader, 0) - var(--heightToolbar, 0) - 2rem)',
                  });

              }, 66);
            });

          // accordion for the 3rd tier links:
          $(_selector__kinkind_check)
            .addClass('event-listener-assigned')
            .on('click', function ( event ) {
              let
                $this             = $(this),
                _this_data_target = $this.data('target'),
                $this_data_parent = $(`[data-parent="${_this_data_target}"]`);
              $this_data_parent
                .toggleClass('.slide-nav__dropdown--hidden')
                .slideToggle();
              $this
                .find('svg')
                .toggleClass('rotate');
            });

          // Finally clear the interval so it's not constantly checking if the menu exists.
          if ( $(`${_selector__kinkind_check}.event-listener-assigned`).length > 0 ) {
            _kinkind_mobile_nav_event_listeners_assigned = true;

            // Only clear the interval if the event listeners are still there.
            clearInterval(_kinkind_mobile_nav_interval);
          }
        }
        else if ( $(_selector__original_check).length > 0 ) {
          // The original theme methods are being used - clear the interval and exit.
          clearInterval(_kinkind_mobile_nav_interval);
        }

        // otherwise, keep checking to see if the menu has loaded yet.
      }, 222);
    }, 222);

    /* endregion */

  });
})(jQuery);
